var _g, _g2, _title;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "file_type_solidity")), /*#__PURE__*/React.createElement("path", {
    d: "M20.477,2l-4.5,8h-9l4.5-8h9",
    style: {
      fill: "#006eff",
      opacity: 0.45,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.52,30l4.5-8h9l-4.5,8h-9",
    style: {
      fill: "#006eff",
      opacity: 0.45,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.975,10h9l-4.5-8h-9Z",
    style: {
      fill: "#006eff",
      opacity: 0.6,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.022,22h-9l4.5,8h9Z",
    style: {
      fill: "#006eff",
      opacity: 0.6,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.477,18l4.5-8-4.5-8-4.5,8Z",
    style: {
      fill: "#006eff",
      opacity: 0.8,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.52,14l-4.5,8,4.5,8,4.5-8Z",
    style: {
      fill: "#006eff",
      opacity: 0.8,
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidity);
export default __webpack_public_path__ + "static/media/solidity.fe174cf402a1c3e45689cf157f92f12d.svg";
export { ForwardRef as ReactComponent };